/**
 * 编辑素材组
 */

import { Modal, Button, Form, Input, InputNumber } from 'antd';
import React from 'react';
import { VerifyEditFormData, ItemDataOPeration } from '../../type';

interface IEditGroupProps {
  visible: boolean;
  onCancel: () => void;
  handleOk: (data: { name: string; totalNum: number }) => void;
  itemData: ItemDataOPeration;
  type: string;
}

const EditGroup = (props: IEditGroupProps) => {
  const { visible, onCancel, handleOk, itemData, type } = props;
  const [editFormRef] = Form.useForm<VerifyEditFormData>();

  const handleSave = async () => {
    try {
      const res = await editFormRef.validateFields();
      handleOk(res);
    } catch (e) {}
  };

  const initialValues = {
    name: itemData.name || '',
    totalNum: itemData.num || 1,
  };
  return (
    <Modal title={`${type === 'add' ? '新增' : '编辑'}商品组`} visible={visible} onCancel={onCancel} footer={null}>
      <Form form={editFormRef} initialValues={initialValues}>
        <Form.Item name="name" label="商品组名称" rules={[{ required: true, message: '必填' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="totalNum" label="展示数量" rules={[{ required: true, message: '必填' }]}>
          <InputNumber style={{ width: 100 }} />
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => onCancel()}>取消</Button>
          <Button type="primary" htmlType="submit" style={{ marginLeft: 10 }} onClick={handleSave}>
            确定
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditGroup;
